import { Model, View } from '@lernetz/ts-lib';

import pageTemplate from './Page.html';
import topicPageTemplate from './TopicPage.html';
import { TopicPageSection } from './TopicPageSection';
import {NavigationRequest} from '../nav-bar/NavBar';
import { Asset } from '../Asset';
import { CoverImage, CoverImageView } from './CoverImage';
import { Cartoon } from '../cartoon/Cartoon';

export class Page extends Model {

    public readonly elements: object[];
    public readonly cover: object;
    public readonly coverSmall: object;
    public readonly subtitle: string;
    public readonly title: string;
    public sidePanelOpen: boolean;

    constructor(dto) {
        super({
            elements: [],
            cover: null,
            coverSmall: null,
            sidePanelOpen: false,
            subtitle: '',
            title: '',
            ...dto,
        });
    }

    public onNavigationRequest(request: NavigationRequest) {
        if( request === 'toggle-sidepanel' ) {
            this.sidePanelOpen = !this.sidePanelOpen;
        }
    }
}


export class TopicPage extends Page {

    public readonly annotationElements: object[];
    public readonly color: string;
    public readonly duration: string;
    public readonly goals: string[];
    public readonly sections: TopicPageSection[];
    public readonly currentSection: TopicPageSection;

    constructor(dto) {
        super({
            color: '',
            duration: '',
            ...dto,
            goals: (dto.goals || []).map(g => g.text),
        });
        this.annotationElements = dto.annotationElements || [];
        this.sections = dto.sections;
        this.currentSection = this.sections?.length ? this.sections[0] : null;
    }
}


export class PageView extends View<Page> {

    static getTemplateFor(page: Page) {
        if (page instanceof TopicPage) {
            return topicPageTemplate;
        }
        else {
            return pageTemplate;
        }
    }

    constructor(page: Page) {
        super({ data: page, template: PageView.getTemplateFor(page) });
    }

    init() {
        if (this.data.cover) {
            const coverNode = this.node.querySelector<HTMLElement>( '.cover' );
            if( this.data.cover instanceof Asset ) {
                // TODO: This is a hack. Non-topic pages don't have a `CoverImage`, so we need to
                // pretend they have one in order to have the responsive CSS stylesheet generated.
                // It would be much better to have dedicated `Page` subclasses for `StartPage` and
                // `TopicPage`... that's long overdue.
                var coverImageView = new CoverImageView();
                coverImageView.data = new CoverImage( {
                    image: <Asset>this.data.cover,
                    imageSmall: <Asset>this.data.coverSmall,
                } );
                coverImageView.render();
                coverNode.id = coverImageView.node.id;
            }
            else if( this.data.cover instanceof Cartoon ) {
                this.data.cover.allowHorizontalOverflow = true;
                coverNode.classList.add( '-cartoon' );
            }

            this.node.classList.remove('-no-cover-displayed');
        }

        this.data.propertyChange.filter(p => p.name === 'sidePanelOpen').subscribe(() => {
            const which = this.data.sidePanelOpen ? 'close' : 'open';
            document.querySelector<HTMLElement>(`[js-sidepanel-${which}-toggle]`)?.focus();
        });
    }

}
